import { Reducer } from 'redux';
import { SchoolSettingsState, SchoolSettingsTypes } from './types';

export const INITIAL_STATE: SchoolSettingsState = {
  schoolSettingsData: {
    id: '',
    paymentType: null,
    creditExpirationLink: null,
    creditExpirationDays: null,
    createdAt: null,
    updatedAt: null,
    transportOperatorId: '',
  },
  loading: false,
  error: false,
};

const reducer: Reducer<SchoolSettingsState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // CASES GET SCHOOL SETTINGS
    case SchoolSettingsTypes.GET_SCHOOL_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        schoolSettingsData: INITIAL_STATE.schoolSettingsData,
      };
    case SchoolSettingsTypes.GET_SCHOOL_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schoolSettingsData: action.payload.schoolSettingsData,
      };
    case SchoolSettingsTypes.GET_SCHOOL_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schoolSettingsData: INITIAL_STATE.schoolSettingsData,
      };

    // CASES UPDATE_SCHOOL_SETTINGS
    case SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        schoolSettingsData: INITIAL_STATE.schoolSettingsData,
      };
    case SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schoolSettingsData: action.payload.schoolSettingsData,
      };
    case SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schoolSettingsData: INITIAL_STATE.schoolSettingsData,
      };

    // CASES UPDATE_SCHOOL_SETTINGS_INDIVIDUAL
    case SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_INDIVIDUAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        schoolSettingsData: INITIAL_STATE.schoolSettingsData,
      };
    case SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_INDIVIDUAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schoolSettingsData: action.payload.schoolSettingsData,
      };
    case SchoolSettingsTypes.UPDATE_SCHOOL_SETTINGS_INDIVIDUAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schoolSettingsData: INITIAL_STATE.schoolSettingsData,
      };

    default:
      return { ...state };
  }
};

export default reducer;
